import React, { FC, ReactNode, useEffect, useState } from 'react'
import styles from 'styles/components/accordion.module.scss'
import text from 'styles/utility/text.module.scss'
import { CheckoutStatusType } from 'types/checkout'
import { GreyTag } from 'components/Tag'

type Props = {
  basketNumber: string
  expandStatus: string
  resetExpandedStatus: () => void
  price: number
  status: CheckoutStatusType
  children: ReactNode
}

const RevenueAccordion: FC<Props> = (props) => {
  const { children, basketNumber, expandStatus, price, resetExpandedStatus, status } = props

  const [open, setOpen] = useState<boolean>(false)
  const toggleOpen = () => {
    resetExpandedStatus()
    setOpen((prevState) => !prevState)
  }

  // 一括で開く/閉じる
  useEffect(() => {
    if (expandStatus === 'expanded') {
      setOpen(true)
    } else if (expandStatus === 'folded') {
      setOpen(false)
    }
  }, [expandStatus])

  return (
    <div className={open ? styles.open : ''}>
      <p className={styles.revenue} onClick={toggleOpen}>
        <div>
          <span className={text.color_grey_01}>受け渡し番号：</span>
          <span className={text.font_bold}>{basketNumber}</span>
        </div>
        {status === 'requires_capture' && <GreyTag tagName={'仮売上'} />}
        <span className={styles.revenue__price}>{price.toLocaleString()}円(税込)</span>
        <span className={styles.revenue__arrow} />
      </p>
      {children}
    </div>
  )
}

export default RevenueAccordion
